import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcessDatevParamStatus: 'idle',
    startProcessDatevParamError: undefined as any,
    loadUserParamsProcessDatevParamStatus: 'idle',
    loadUserParamsProcessDatevParamError: undefined as any,

    processDatevParamList: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcessDatevParam = createAsyncThunk('processDatevParamSlice/startProcessDatevParam', async ({ processDatevParam }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcessDatevParam/`,
        prepareData(processDatevParam),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcessDatevParamStatus } = getState().processDatevParamSlice
        return startProcessDatevParamStatus !== 'pending'
    }
})

export const loadUserParamsProcessDatevParam = createAsyncThunk('processDatevParamSlice/loadUserParamsProcessDatevParam', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcessDatevParam/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcessDatevParamStatus } = getState().processDatevParamSlice
        return loadUserParamsProcessDatevParamStatus !== 'pending'
    }
})

const ProcessDatevParamSlice = createSlice({
    name: 'processDatevParamSlice',
    initialState,
    reducers: {
        resetstartProcessDatevParam: (state) => {
            state.job = undefined
            state.startProcessDatevParamError = undefined
        },
        resetstartProcessDatevParamError: (state) => {
            state.startProcessDatevParamError = undefined
        },
        resetloadUserParamsProcessDatevParam: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcessDatevParamError = undefined
        },
        resetloadUserParamsProcessDatevParamError: (state) => {
            state.loadUserParamsProcessDatevParamError = undefined
        },
        removeFromProcessDatevParamListById: (state, action) => {
            state.processDatevParamList = state.processDatevParamList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcessDatevParamListByIds: (state, action) => {
            state.processDatevParamList = state.processDatevParamList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.processDatevParamList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcessDatevParamStatus = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.processDatevParamList = []
            state.startProcessDatevParamStatus = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcessDatevParam.pending, (state) => {
            state.startProcessDatevParamStatus = 'pending'
            state.startProcessDatevParamError = undefined
        })
        builder.addCase(startProcessDatevParam.fulfilled, (state, action) => {
            state.startProcessDatevParamStatus = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcessDatevParam.rejected, (state, action) => {
            state.startProcessDatevParamStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcessDatevParamError = action.error.message
            } else {
                state.startProcessDatevParamError = action.payload
            }
        })

        builder.addCase(loadUserParamsProcessDatevParam.pending, (state) => {
            state.loadUserParamsProcessDatevParamStatus = 'pending'
            state.loadUserParamsProcessDatevParamError = undefined
        })
        builder.addCase(loadUserParamsProcessDatevParam.fulfilled, (state, action) => {
            state.loadUserParamsProcessDatevParamStatus = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcessDatevParam.rejected, (state, action) => {
            state.loadUserParamsProcessDatevParamStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcessDatevParamError = action.error.message
            } else {
                state.loadUserParamsProcessDatevParamError = action.payload
            }
        })

    }
})

export const {
    resetstartProcessDatevParam,
    resetstartProcessDatevParamError,
    resetloadUserParamsProcessDatevParam,
    resetloadUserParamsProcessDatevParamError,
    removeFromProcessDatevParamListById,
    removeFromProcessDatevParamListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = ProcessDatevParamSlice.actions
export default ProcessDatevParamSlice.reducer
